import store from '@/store';
import axios from "axios";

class Global {
    constructor() {
    }

    static status(appendBlank = false) {
        let d = [
            {id: '10', name: '自動'},
            {id: '4', name: '不備(通)'},
            {id: '5', name: '不備(業)'},
        ];
        if (appendBlank) {
            d.unshift({id: '', name: ''});
        }
        return d;
    };

    static showStatus(appendBlank = false) {
      let d = [
          {id: '0', name: 'Pre-Alert'},
          {id: '1', name: '手配中'},
          {id: '2', name: '出港済み'},
          {id: '3', name: '完了'},
          {id: '4', name: '不備(通)'},
          {id: '5', name: '不備(業)'},
      ];
      if (appendBlank) {
          d.unshift({id: '', name: ''});
      }
      return d;
  };

    static showStatusEn(appendBlank = false) {
        let d = [
            {id: '0', name: 'Pre-Alert'},
            {id: '1', name: 'Under Arrangement'},
            {id: '2', name: 'Departed'},
            {id: '3', name: 'Completion'},
            {id: '4', name: 'Deficiency(CC)'},
            {id: '5', name: 'Deficiency(B)'},
        ];
        if (appendBlank) {
            d.unshift({id: '', name: ''});
        }
        return d;
    };

    static workingStyle(appendBlank = false) {
        let d = [
            {id: 1, name: '海上'},
            {id: 2, name: '業務'},
            {id: 3, name: '通関'},
            {id: 4, name: '倉庫'},
            {id: 5, name: 'その他'},
        ];
        if (appendBlank) {
            d.unshift({id: '', name: ''});
        }
        return d;
    };

    static shippingForm(appendBlank = false) {
        let d = [
            {id: '0', name: '未選択'},
            {id: '1', name: 'CY'},
            {id: '2', name: 'LCY'},
            {id: '3', name: 'CFS'},
            {id: '4', name: 'LCFS'},
            {id: '5', name: 'AIR'},
            {id: '6', name: 'BULK'},
            {id: '7', name: '未手数'},
            {id: '8', name: 'その他'},
        ];
        if (appendBlank) {
            d.unshift({id: '', name: ''});
        }
        return d;
    };

    static customsClearance(appendBlank = false) {
        let d = [
            {id: '0', name: '未選択'},
            {id: '1', name: 'CYヤード'},
            {id: '2', name: '自社倉庫'},
            {id: '3', name: '他社倉庫'},
            {id: '4', name: 'その他'},
        ];
        if (appendBlank) {
            d.unshift({id: '', name: ''});
        }
        return d;
    };

    static customMaterial(appendBlank = false) {
      let d = [
          {id: '2', name: 'IV'},
          {id: '3', name: 'PL'},
          {id: '4', name: '貨物明細'},
          {id: '5', name: 'その他'},
      ];
      if (appendBlank) {
          d.unshift({id: '', name: ''});
      }
      return d;
    };

    static customMaterialEn(appendBlank = false) {
      let d = [
          {id: '2', name: 'IV'},
          {id: '3', name: 'PL'},
          {id: '4', name: 'Detail'},
          {id: '5', name: 'Other'},
      ];
      if (appendBlank) {
          d.unshift({id: '', name: ''});
      }
      return d;
    };

    static level(appendBlank = false) {
        let d = [
            {id: 0, name: '一般'},
            {id: 1, name: '管理者'},
        ];
        if (appendBlank) {
            d.unshift({id: '', name: ''});
        }
        return d;
    };

    static levelEn(appendBlank = false) {
      let d = [
          {id: 0, name: 'General'},
          {id: 1, name: 'Administrator'},
      ];
      if (appendBlank) {
          d.unshift({id: '', name: ''});
      }
      return d;
  };

    static partnerLabel() {
        let d = {
            status: 'Status',
            rv: 'RV',
            agent_comment_flg: 'CMT',
            shipper_name: 'Shipper',
            consignee: 'Consignee',
            place_of_receipt: 'Place of Receipt',
            cargo_location: 'Delivery Place',
            booking: 'Booking No.',
            quantity: 'Quantity',
            sts_ship: 'STS SHIP',
            container_info: 'Container Nos / Size',
            custom_materials_flg: 'Customs\nDocuments',
            vehicle_information_flg: 'Driver\nInfo',
            picture_flg: 'Photo',
            carry_in_slip_flg: 'CTR Info',
            export_permit_flg: 'Declaration',
            draft_bl_flg: 'Draft BL',
            hbl_flg: 'HBL',
            mbl_flg: 'MBL',
            debit_note_flg: 'Debit\nNote'
        }
        return d;
    };

    static fcLabel() {
      let d = {
          status: 'ステータス',
          rv: 'RV',
          comment_flg: 'CMT',
          input_date: '入力日',
          shipper_name: '荷主',
          booking: 'booking No.',
          ship_name: '船名/便名',
          voy: 'VOY',
          place_of_receipt: '荷受け地',
          loading_area: '積地',
          landing_area: '揚げ地',
          departure_date: '出港日',
          cut_date: 'CUT日',
          quantity: '個数',
          sts_ship: '区分',
          container_info: 'コンテナ本数・サイズ',
          pick_up_flg: '引き取り有無',
          pick_up_date: '引き取り日',
          pick_up_time: '引き取り時間',
          working_style: '作業形態',
          shipping_form: '船積形態',
          customs_clearance: '通蔵',
          cargo_location: '貨物搬入先場所',
          ledger_number: '台帳番号',
          custom_materials_flg: '通関資料',
          ms_i_flg: 'M S/I',
          hs_i_flg: 'H S/I',
          vehicle_information_flg: '配車情報',
          picture_flg: '写真',
          carry_in_slip_flg: '搬入票',
          acl_flg: 'ACL',
          export_permit_flg: '輸出許可証',
          draft_bl_flg: 'Draft BL',
          freight_detail_flg: 'FREIGHT明細',
          debit_note_flg: 'Debit Note',
          hbl_flg: 'HBL',
          mbl_flg: 'MBL',
      }
      return d;
  };

  static hoursList(appendBlank = false) {
    let d = [
      {id: '00', name: '00'},
      {id: '01', name: '01'},
      {id: '02', name: '02'},
      {id: '03', name: '03'},
      {id: '04', name: '04'},
      {id: '05', name: '05'},
      {id: '06', name: '06'},
      {id: '07', name: '07'},
      {id: '08', name: '08'},
      {id: '09', name: '09'},
      {id: '10', name: '10'},
      {id: '11', name: '11'},
      {id: '12', name: '12'},
      {id: '13', name: '13'},
      {id: '14', name: '14'},
      {id: '15', name: '15'},
      {id: '16', name: '16'},
      {id: '17', name: '17'},
      {id: '18', name: '18'},
      {id: '19', name: '19'},
      {id: '20', name: '20'},
      {id: '21', name: '21'},
      {id: '22', name: '22'},
      {id: '23', name: '23'},
    ];
    if (appendBlank) {
        d.unshift({id: '', name: ''});
    }
    return d;
  };

  static minutes(appendBlank = false) {
    let d = [
      {id: '00', name: '00'},
      {id: '15', name: '15'},
      {id: '30', name: '30'},
      {id: '45', name: '45'},
    ];
    if (appendBlank) {
        d.unshift({id: '', name: ''});
    }
    return d;
  };

    static ymd() {
        const date = new Date();
        return date.getFullYear() + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + (date.getDate())).slice(-2);
    }

    static hms() {
        const date = new Date();
        return ('0' + date.getHours()).slice(-2) + ':' + ('0' + (date.getMinutes())).slice(-2);
    }

    /**
     * 指定されたインデックスの値を返却する
     */
    static getGroupIndexValue(group, index, label) {
        try {
            if (group != null) {
                if (index != null) {
                    return store.getters.getPostParam[group][index][label];
                } else {
                    return store.getters.getPostParam[group][label];
                }
            } else {
                if (index != null) {
                    if (!store.getters.getPostParam[label]) {
                        return store.getters.getPostParam[label];
                    }
                    return store.getters.getPostParam[label][index];
                }
            }
            return store.getters.getPostParam[label];
        } catch (e) {
        }
        return '';
    }

    /**
     * 指定されたインデックスが存在するかを調べる
     */
    static hasGroupIndexValue(group, index, label) {
        try {
            if (group != null) {
                if (index != null) {
                    if (!store.getters.getPostParam[group][index][label]) {
                        return false;
                    }
                } else {
                    if (!store.getters.getPostParam[group][label]) {
                        return false;
                    }
                }
                return true;
            } else if (index != null) {
                if (!store.getters.getPostParam[label]) {
                    if (!store.getters.getPostParam[label]) {
                        return false;
                    }
                } else {
                    if (!store.getters.getPostParam[label][index]) {
                        return false;
                    }
                }
            } else {
                if (!store.getters.getPostParam[label]) {
                    return false;
                }
            }
            return true;
        } catch (e) {
        }
        return false;
    }

    /**
     * 消費税加算
     */
    static tax(price) {
        return parseInt(price * 1.1, 10);
    }

    /**
     * 数値のカンマ区切りを行う
     */
    static comma(num) {
        return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
}

export default Global;